<template>
  <div class="CommonContentSingle-gray Crisis_upreport">
    <el-container>
      <el-header style="background:rgba(255, 255, 255, 1);min-height:80px;height:auto;">

        <el-form  :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline" style="margin: 0px 0px;background:rgba(255, 255, 255, 1);padding: 10px;height: 92px;">
          <el-form-item label="综合查询">
            <el-input
              placeholder="账号/学号/身份证号/姓名"
              v-model="ruleForm.Name"
            ></el-input>
          </el-form-item>

          <el-form-item label="部门">
            <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="DeptID" filterable  :options="optionsnew"  :props="{ checkStrictly: true }" clearable></el-cascader>
          </el-form-item>

          <el-form-item label="年级">
            <el-select v-model="ruleForm.EntryDate" placeholder="请选择年级">
              <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="学位">
            <el-select v-model="ruleForm.Degree" placeholder="请选择学位">
              <el-option label="本科生" value="本科生"></el-option>
              <el-option label="硕士研究生" value="硕士研究生"></el-option>
              <el-option label="博士研究生" value="博士研究生"></el-option>
            </el-select>
          </el-form-item> -->

          <!-- <el-form-item label="上报类型">
            <el-select v-model="ruleForm.Type" placeholder="请选择上报类型">
              <el-option label="日常危机上报" value="日常危机上报"></el-option>
              <el-option label="心理测评" value="心理测评"></el-option>
              <el-option label="预制表" value="预制表"></el-option>
            </el-select>
          </el-form-item> -->
<!-- 
          <el-form-item label="上报状态">
            <el-select  v-model="ruleForm.ReportStatus" placeholder="请选择上报状态">
              <el-option label="待填写预制表" value="1"></el-option>
              <el-option label="待风险监控员初审" value="2"></el-option>
              <el-option label="无法确定" value="3"></el-option>
              <el-option label="无需干预" value="4"></el-option>
              <el-option label="待危机主管复核" value="5"></el-option>
              <el-option label="待中心主任审核" value="6"></el-option>
              <el-option label="待上报" value="7"></el-option>
              <el-option label="已上报" value="8"></el-option>
              <el-option label="未提交" value="9"></el-option>
              <el-option label="风险监控员审核驳回" value="10"></el-option>
              <el-option label="危机主管审核驳回" value="11"></el-option>
              <el-option label="中心主任审核驳回" value="12"></el-option>
            </el-select>
          </el-form-item> -->
          <el-button type="primary" @click="onSelect()">查询</el-button>
          <el-button type="primary" @click="resetForm()" style="margin-top: 5px;margin-left:10px">重置</el-button>
        </el-form>
      </el-header>

      <div style="height:100%;background-color: #fff;margin-top: 20px;">
        <el-table :data="tableData" stripe style="width: 100%;">

          <el-table-column label="序号" width="60px" align="left">
            <template slot-scope="scope" center>
              {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column label="学生学号">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.UserId }}</span>
            </template>
          </el-table-column>

          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.RealName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="培养单位">
            <template slot-scope="scope">
              <span>{{ scope.row.DeptName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="记录人">
            <template slot-scope="scope">
              <span>{{ scope.row.RecordName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="记录时间">
            <template slot-scope="scope">
              <span>{{ scope.row.RecordTime }}</span>
            </template>
          </el-table-column>

          <el-table-column label="记录类型">
            <template slot-scope="scope">
              <span>{{ scope.row.RecordType }}</span>
            </template>
          </el-table-column>

          <el-table-column label="危机调整">
            <template slot-scope="scope">
              <span v-if="scope.row.AdjustBefore =='1'" style="color: #FF0808;">红色预警</span>
              <span v-else-if="scope.row.AdjustBefore == '2'" style="color: #A68F52;">橙色预警</span>
              <span v-else-if="scope.row.AdjustBefore == '3'" style="color: #E6A707;">黄色预警</span>
              <span v-else-if="scope.row.AdjustBefore == '4'" style="color: rgba(0, 136, 255, 1);">蓝色预警</span>
              <span v-else-if="scope.row.AdjustBefore == '5'" style="color: rgb(2 158 1);"> 绿色预警</span>
              ->
              <span v-if="scope.row.AdjustNow == '1'" style="color: #FF0808;">红色预警</span>
              <span v-else-if="scope.row.AdjustNow == '2'" style="color: #A68F52;">橙色预警</span>
              <span v-else-if="scope.row.AdjustNow == '3'" style="color: #E6A707;">黄色预警</span>
              <span v-else-if="scope.row.AdjustNow == '4'" style="color: rgba(0, 136, 255, 1);">蓝色预警</span>
              <span v-else-if="scope.row.AdjustNow == '5'" style="color: rgb(2 158 1);"> 绿色预警</span>
            </template>
          </el-table-column>

          <el-table-column label="记录状态">
            <template slot-scope="scope">
              <span>{{ scope.row.RecordStatus }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column label="查看档案">
            <template slot-scope="scope">
              <span>{{ scope.row.RecordStatus }}</span>
            </template>
          </el-table-column> -->

          <!-- <el-table-column class="xsii" prop="address" label="操作" v-if="this.Global.pdroleid(1071)">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.RecordStatus == '心理委员保存'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Memcon_modify(scope.row.UserId, scope.row.TalkNo)">内容修改</span>
                <span v-if="scope.row.RecordStatus == '--'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="jump(scope.row.UserId, scope.row.TalkNo, scope.row.KeyNo)">谈心谈话</span>
                <span v-else-if="scope.row.RecordStatus == '心理委员提交' || scope.row.RecordStatus == '辅导员保存' || scope.row.RecordStatus == '辅导员提交' || scope.row.RecordStatus == '待风险监控员初审' || scope.row.RecordStatus == '待咨询师评估' || scope.row.RecordStatus == '待咨询师审核' || scope.row.RecordStatus == '待危机主管复核' || scope.row.RecordStatus == '待中心主任审核' || scope.row.RecordStatus == '已结案' || scope.row.RecordStatus == '未结案'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_Memcon_view(scope.row.TalkNo)">查看详情</span>
                <span v-if="scope.row.RecordStatus == '未结案'" @click="jumptanx(scope.row.UserId, scope.row.TalkNo, scope.row.KeyNo)" style="cursor: pointer;color: rgb(31, 52, 245);">
                  谈心谈话
                </span>
              </div>
            </template>
          </el-table-column> -->
        </el-table>

        <el-pagination style="margin-top:20px;text-align:right" @current-change="handleCurrentChange" :current-page.sync="pageIndexs" :page-size="10"  layout="total, prev, pager, next" :total="Count" v-if="Count > 0"></el-pagination>

      </div>

    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      gradedata:[],
      RoleID: '',
      jiaose: '辅导员',
      DeptID: '',
      optionsnew: [],
      Count: 0,
      pageIndexs: 1,
      ruleForm: {
        Name: '', //综合查询
        DeptID: '', //培训单位
        EntryDate: '', //年级
        Degree: '', //学位
        Type: '', //上报类型
        ReportStatus: '', //上报状态
        pageIndex: 1,
        pageSize: '10',
      },
      form: {
        DeptName: '',
        RealName: '',
        Status: '',
        UserID: '',
        entity: '管理员',
        pageIndex: 1,
        pageSize: '10',
      },
      tableData: [],
    };
  },
  methods: {
    jumptanx(UserId, TalkNo, KeyNo) {
      this.$router.push({ path: '/Crisis/Memcon', query: { UserId: UserId, TalkNo: TalkNo, KeyNo: KeyNo } });
    },
    Prefabricated_table(KeyNo) {
      //填写预制表
      this.$router.push({
        path: '/Crisis/Crisis_addmajor_event',
        query: { KeyNo: KeyNo },
      });
    },
    Crisis_Memcon_view(TalkNo) {
      this.$router.push({
        path: '/Crisis/Crisis_Memcon_view',
        query: { TalkNo: TalkNo },
      });
    },
    Crisis_Memcon_audit(TalkNo,KeyNo) {
      this.$router.push({
        path: '/Crisis/Crisis_Memcon_audit',
        query: { TalkNo: TalkNo, KeyNo : KeyNo},
      });
    },
    Selected_to_shut_dow(dt) {
      this.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break;
        } else if (
          NodeList[i].fuzi &&
          NodeList[i].children.length > 0 &&
          NodeList[i].children[0].DeptID != '-1'
        ) {
          this.GetNodeByDeptID(ID, NodeList[i].children);
        }
      }
      return obj;
    },
    bumen(dt) {
      let obj = this.optionsnew[0];
      for (let i = 0; i < this.optionsnew.length; i++) {
        if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
          obj = this.optionsnew[i];
          break;
        } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.optionsnew[i].children,
          );
        }
      }
      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...' }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: dt[dt.length - 1],content: '',}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },
    gourl(val) {
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: a },
      });
      window.open(routeData.href, '_blank');
    },
    ceshigorl() {
      this.$router.push('/Crisis/Crisis_intervention?id=111');
    },
    load(form) {//列表
      this.$Http_Post('DistressPrediction/UrgentIntervention', {
        pageSize: '10',
        pageIndex: this.ruleForm.pageIndex,
        Name: this.ruleForm.Name,
        DeptID: this.DeptID,
        EntryDate: this.ruleForm.EntryDate,
        Degree: this.ruleForm.Degree,
        Type: this.ruleForm.Type,
        Status: this.ruleForm.ReportStatus,
        RoleID: this.RoleID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.Count = res.Counts;
        }
      });
    },

    handleCurrentChange(val) {//分页点击
      this.ruleForm.pageIndex = val;
      this.load(this.form);
    },

    Go_Review_key(val) {
      sessionStorage.setItem('Crisis_upreport_type', val.row.UrgentStatus);
      this.$router.push({
        path: '../Crisis/Review_key',
        query: {id: val.row.userid,SourceNo: val.row.SourceNo,TableCngResultID: val.row.TableCngResultID},
      });
    },

    resetForm() {
      this.ruleForm.Name = '';
      this.ruleForm.DeptID = '';
      this.ruleForm.EntryDate = '';
      this.ruleForm.Degree = '';
      this.ruleForm.ReportType = '';
      this.ruleForm.ReportState = '';
      this.ruleForm.pageIndex = 1;
      this.load();
    },
    onSelect() {
      this.load();
    },
    Memcon_modify(UserId, TalkNo) {
      this.$router.push({ path: '/Crisis/Memcon_modify', query: { UserId: UserId, TalkNo: TalkNo } });
    },
    jump(UserId, TalkNo, KeyNo) {
      this.$router.push({ path: '/Crisis/Memcon', query: { UserId: UserId, TalkNo: TalkNo, KeyNo: KeyNo } });
    },
    jum2p(val) {
      this.$router.push({ path: '/Crisis/report', query: { id: val } });
    },
  },
  mounted() {
    this.RoleID = sessionStorage.getItem('RoleID');
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data
      }
    })
    this.load(this.form);
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: '',content: ''}).then((res) => {
      if (res.Data) {
        this.optionsnew = res.Data;
        this.DeptID = res.Data[0].DeptID;
        this.chongzhiDeptID = res.Data[0].DeptID;
      }
    });
  },
  filters: {
    dateFormat(datetime) {
      var dt = new Date(datetime);
      var y = dt.getFullYear();
      var M = dt.getMonth() + 1;
      var d = dt.getDate();
      var h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
      var m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes();
      var s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds();
      return `${y}-${M}-${d} ${h}:${m}:${s}`;
    },
  },
};
</script>

<style>
.Crisis_upreport button {
  margin-bottom: 20px;
}

.Crisis_upreport .cell span {
  margin-left: 10px;
  text-align: center;
}

.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
</style>
